import React, { useState } from "react";
import Button from "@components/Ui/Button";
import MoviesComingSoon from "@components/V3/Movies/MoviesComingSoon";
import MoviesNowShowing from "@components/V3/Movies/MoviesNowShowing";
import "./style.scss";

const MoviesList = () => {
    const [showCurrent, setShowCurrent] = useState(true);

    return (
        <div className="movie-list">
            <div className="movie-list__header">
                <ul className="movie-list__buttons">
                    <li className="movie-list__item">
                        <Button
                            additionalClasses={`button movie-list__button ${showCurrent ? "movie-list__button-selected" : ""}`}
                            onClick={() => setShowCurrent(true)}>
                            Now Showing
                        </Button>
                    </li>
                    <li className="movie-list__item">
                        <Button
                            additionalClasses={`button movie-list__button ${!showCurrent ? "movie-list__button-selected" : ""}`}
                            onClick={() => setShowCurrent(false)}>
                            Coming Soon
                        </Button>
                    </li>
                </ul>
            </div>

            {showCurrent && (
                <MoviesNowShowing />
            )}
            {!showCurrent && (
                <MoviesComingSoon />
            )}
        </div>
    );
};

export default MoviesList;
